@if (asString; as string) {
  <p class="padding-vertical-4 padding-horizontal-8">
    <small>{{ string }}</small>
  </p>
}

@if (asTemplate; as template) {
  <ng-template [ngTemplateOutlet]="template"></ng-template>
}
